module.exports = __webpack_public_path__ + "img/icon_modeSelect_hk.2fc0d663.png";